// Bildschirm fuer eine Adresse, die es nicht gibt (ST-UX-001, NFR-UX-005).
//
// Er existiert, weil Adressen ab jetzt geteilt und mit einem Lesezeichen
// versehen werden. Ein veralteter Link darf nicht stillschweigend auf der
// Startseite landen: die Nutzerin glaubt dann, sie sei am Ziel, und sucht
// anschliessend etwas, das dort nie war.

import type { ReactElement } from 'react';

import { useSchnellzugriff } from '../shell/kontextbefehle.ts';
import { useUeberschriftImInhalt } from '../shell/layout.tsx';
import { Zustand } from '../shell/zustand.tsx';

export function NotFoundScreen(): ReactElement {
  const schnellzugriff = useSchnellzugriff();
  // Der Zustand traegt die h1 und die Karte selbst (v4 v13).
  useUeberschriftImInhalt();
  return (
    <Zustand
      art="nicht-da"
      titel="Diese Adresse gibt es nicht"
      saetze={[
        'Der Link ist entweder veraltet oder enthält einen Tippfehler.',
        'Wähle oben einen Bereich aus. Dein Zugang und deine Daten sind davon nicht betroffen.',
        'Falls du den Link von jemandem bekommen hast, frage nach der aktuellen Adresse.',
      ]}
      haupt={{ label: 'Zu den Kontakten', href: '/kontakte' }}
      {...(schnellzugriff === undefined ? {} : { neben: { label: 'Kontakt finden', onClick: schnellzugriff } })}
    />
  );
}
